import {post} from '@/utils/request';
import {erpserver} from '@/utils/baseUrl';
//获取领用申请列表
export async function getPickingReqListSc(params) {
    return post(erpserver+'/pickingList/getPickingReqListSc', params, true)
}
//获取仓库
/*export async function getWarehouseList(params) {
    return post(erpserver+'/currency/getWarehouseList', params, true)
}
// 获取申请人
export async function getPersonList(params) {
    return post(erpserver+'/currency/getPersonList', params, true);
}
// 获取领用部门
export async function getGroupList(params) {
    return post(erpserver+'/currency/getGroupList', params, true);
}*/
//
export async function getSellDirectUser(params) {
    return post(erpserver+'/pickingList/getSellDirectUser', params, true);
}
// 获取公司
export async function getCompanyList(params) {
    return post(erpserver+'/currency/getCompanyList', params, true);
}
// 获取产品
export async function getProductListSc(params) {
    return post(erpserver+'/pickingList/getProductListSc', params, true);
}

// 获取领料单详情
export async function getPickingListSc(params) {
    return post(erpserver+'/pickingList/getPickingListSc', params, true);
}
// 保存
export async function savePickingListSc(params) {
    return post(erpserver+'/pickingList/savePickingListSc', params, true);
}
